import React, { useState } from "react";
import classes from "./academyRegistrationForm.module.css";
import Step1 from "../../../assets/images/form-step.png";
import NextStep from "../../../assets/images/form-next-step.png";
import FinalStep from "../../../assets/images/form-final-step.png";
import Details from "./details/details";
import Waiver from "./waiver/waiver";
import Checkout from "./checkout/checkout";

const AcademyRegistrationForm = (props) => {
    const [currentStep, setCurrentStep] = useState(1);
    const [registrationId, setRegistrationId] = useState(null);
    const [bookingData, setBookingData] = useState({});
    const [paymentData, setPaymentData] = useState({});

    return (
        <div>
            <div className={classes.Path}>
                <span onClick={() => props.setShowAcademyRegistrationForm(false)}>
                    {parseInt(localStorage.getItem('language')) === 1 ? "Academy" : "الأكاديمية"}
                </span> / 
                {parseInt(localStorage.getItem('language')) === 1 
                    ? "Academy Registration Form" 
                    : "نموذج التسجيل في الأكاديمية"}
            </div>
            <div className={classes.FormContainer}>
                <h1>
                    {parseInt(localStorage.getItem('language')) === 1 
                        ? "Academy Registration Form" 
                        : "نموذج التسجيل في الأكاديمية"}
                </h1>
                <div className={classes.Steps}>
                    <img src={currentStep === 1 ? Step1 : currentStep === 2 ? NextStep : FinalStep} alt='step' />
                    <div className={classes.StepsTitle}>
                        <h3 className={[currentStep === 1 && classes.CurrentStep, currentStep > 1 && classes.DoneStep].join(" ")}>
                            {parseInt(localStorage.getItem('language')) === 1 ? "Details" : "التفاصيل"}
                        </h3>
                        <h3 className={[currentStep === 2 && classes.CurrentStep, currentStep > 2 && classes.DoneStep, currentStep < 2 && classes.NextStep].join(" ")}>
                            {parseInt(localStorage.getItem('language')) === 1 ? "Waiver" : "إخلاء المسؤولية"}
                        </h3>
                        <h3 className={[currentStep === 3 && classes.CurrentStep, currentStep < 3 && classes.NextStep].join(" ")}>
                            {parseInt(localStorage.getItem('language')) === 1 ? "Checkout" : "الدفع"}
                        </h3>
                    </div>
                </div>
                <div>
                    {currentStep === 1 ? <Details setRegistrationId={setRegistrationId} setBookingData={setBookingData}
                        setCurrentStep={setCurrentStep} currentStep={currentStep} academy={props.academy}
                        plans={props.plans} selectedPlan={props.selectedPlan} selectedLocation={props.selectedLocation}
                        setSelectedLocation={props.setSelectedLocation}/> :
                        currentStep === 2 ? <Waiver registrationId={registrationId} setPaymentData={setPaymentData}
                        setCurrentStep={setCurrentStep} currentStep={currentStep} /> :
                            currentStep === 3 && <Checkout registrationId={registrationId} paymentData={paymentData}
                            setCurrentStep={setCurrentStep} currentStep={currentStep} bookingData={bookingData}
                            showAcademyRegistrationForm={props.setShowAcademyRegistrationForm}/>}
                </div>
            </div>
        </div>
    )
}

export default AcademyRegistrationForm;